import axiosInstance from "../../apiAxios/axiosInstance";


export const SizeList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/size-list",payload);
   return resposne.data
};
export const ActiveSizeList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-size-list",payload);
   return resposne.data
};
// Create
export const AddSize = (payload) => {
  return axiosInstance.post("/admin/size-store", payload);
};

// Show
export const ViewSize = (payload) => {
  return axiosInstance.post("/admin/size-show", payload);
};

// Update
export const UpdateSize = (payload) => {
  return axiosInstance.post("/admin/size-update", payload);
};

// Delete
export const DeleteSize = async(payload) => {
 const response= await axiosInstance.post("/admin/size-delete", payload);
 return response.data
};

// Status Change
export const SizeChangeStatus = (payload) => {
  return axiosInstance.post("/admin/size-status-update", payload);
};